import { render } from "./SmsCode.vue?vue&type=template&id=27bc999c&scoped=true"
import script from "./SmsCode.vue?vue&type=script&lang=js"
export * from "./SmsCode.vue?vue&type=script&lang=js"

import "./SmsCode.vue?vue&type=style&index=0&id=27bc999c&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bc999c"]])

export default __exports__